export default "__VITE_ASSET__CDgORzWY__"